/**
 * Help Center
 * - Live client-side filtering of the FAQ section as the customer types.
 * - Smooth, header-aware scrolling for the category tiles.
 * No network requests; the page is fully functional (browse + accordions) without JS.
 */
(function () {
  'use strict';

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this;
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function stickyOffset() {
    var raw = getComputedStyle(document.documentElement).getPropertyValue('--theme-sticky-header-height');
    var n = parseInt(raw, 10);
    return isNaN(n) ? 0 : n;
  }

  function smoothScrollTo(id) {
    var el = document.getElementById(id);
    if (!el) return false;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var y = el.getBoundingClientRect().top + window.pageYOffset - stickyOffset() - 20;
    window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
    return true;
  }

  function initFaq() {
    var faq = document.querySelector('[data-help-faq]');
    if (!faq || faq.dataset.helpBound === 'true') return;
    faq.dataset.helpBound = 'true';

    var search = document.querySelector('[data-help-search]');
    var tiles = document.querySelector('[data-help-tiles]');
    var noResults = faq.querySelector('[data-help-noresults]');
    var groups = Array.prototype.slice.call(faq.querySelectorAll('[data-help-group]'));
    var items = Array.prototype.slice.call(faq.querySelectorAll('[data-help-item]'));

    items.forEach(function (item) {
      item.helpHaystack = item.textContent.toLowerCase().replace(/\s+/g, ' ');
    });

    function reset() {
      faq.classList.remove('is-searching');
      items.forEach(function (item) {
        item.classList.remove('is-hidden');
        item.removeAttribute('open');
      });
      groups.forEach(function (group) { group.classList.remove('is-hidden'); });
      if (tiles) tiles.classList.remove('is-hidden');
      if (noResults) noResults.hidden = true;
    }

    function apply(query) {
      var terms = query.toLowerCase().trim().split(/\s+/).filter(Boolean);

      if (!terms.length) {
        reset();
        return;
      }

      faq.classList.add('is-searching');
      if (tiles) tiles.classList.add('is-hidden');

      var anyVisible = false;
      items.forEach(function (item) {
        var match = terms.every(function (term) { return item.helpHaystack.indexOf(term) >= 0; });
        if (match) {
          item.classList.remove('is-hidden');
          item.setAttribute('open', '');
          anyVisible = true;
        } else {
          item.classList.add('is-hidden');
          item.removeAttribute('open');
        }
      });

      groups.forEach(function (group) {
        var visible = group.querySelector('[data-help-item]:not(.is-hidden)');
        group.classList.toggle('is-hidden', !visible);
      });

      if (noResults) noResults.hidden = anyVisible;
    }

    if (search) {
      var run = debounce(function () { apply(search.value); }, 120);
      search.addEventListener('input', run);
      search.addEventListener('search', run);
    }
  }

  function initTiles() {
    var tiles = document.querySelectorAll('[data-help-tile]');
    Array.prototype.forEach.call(tiles, function (tile) {
      if (tile.dataset.helpBound === 'true') return;
      tile.dataset.helpBound = 'true';
      tile.addEventListener('click', function (evt) {
        var href = tile.getAttribute('href') || '';
        if (href.charAt(0) !== '#') return;
        var id = href.slice(1);
        if (smoothScrollTo(id)) {
          evt.preventDefault();
          if (history.replaceState) history.replaceState(null, '', href);
        }
      });
    });
  }

  function init() {
    initFaq();
    initTiles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: re-init when a Help Center section is re-rendered.
  document.addEventListener('shopify:section:load', init);
})();
